import { render, staticRenderFns } from "./FarmHarvestDetailsView.vue?vue&type=template&id=640e89cb&scoped=true&lang=html&"
import script from "./FarmHarvestDetailsView.vue?vue&type=script&lang=js&"
export * from "./FarmHarvestDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640e89cb",
  null
  
)

export default component.exports